import SplitBorderCircle from '@/components/split-border-circle.tsx'

const LearningStageCircle = ({ learningStage }: { learningStage: number }) => {
	let activeSections = 0
	let activeColor = ''

	if (learningStage === -3) {
		activeSections = 3
		activeColor = 'red'
	} else if (learningStage === -2) {
		activeSections = 2
		activeColor = 'red'
	} else if (learningStage === -1) {
		activeSections = 1
		activeColor = 'red'
	} else if (learningStage === 0) {
		activeSections = 1
		activeColor = 'orange'
	} else if (learningStage === 1) {
		activeSections = 2
		activeColor = 'orange'
	} else if (learningStage === 2) {
		activeSections = 3
		activeColor = 'orange'
	} else if (learningStage === 3) {
		activeSections = 1
		activeColor = 'limegreen'
	} else if (learningStage === 4) {
		activeSections = 2
		activeColor = 'limegreen'
	} else if (learningStage === 5) {
		activeSections = 3
		activeColor = 'limegreen'
	}

	return <SplitBorderCircle activeSections={activeSections} activeColor={activeColor} />
}

export default LearningStageCircle
